// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sayhi-head-beans{width:.72rem;height:.72rem}", ""]);
// Exports
module.exports = exports;
